var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4997 35C26.2622 35 31 30.0251 31 23.8412C31 21.9023 30.0954 19.4703 28.8007 17.0658C26.904 13.5415 24.1872 10.0681 22.4681 8.32926C21.9224 7.77753 21.4631 7.39202 21.1507 7.20702C20.8843 7.04903 20.6553 7 20.4997 7C20.3441 7 20.1151 7.04903 19.8487 7.20702C19.5363 7.39202 19.077 7.77753 18.5319 8.32926C16.8128 10.0681 14.0954 13.5415 12.1987 17.0658C10.904 19.4703 10 21.9023 10 23.8412C10 30.0251 14.7372 35 20.4997 35ZM20.4997 8.27425C20.6105 8.35101 20.7728 8.46931 20.9106 8.59089C21.37 8.99612 21.9622 9.61376 22.6218 10.3805C25.496 13.7213 29.6741 19.867 29.6741 23.8412C29.6741 29.3096 25.5958 33.7946 20.4997 33.7946C15.4036 33.7946 11.3253 29.3096 11.3253 23.8412C11.3253 19.867 15.5034 13.7213 18.3776 10.3805C19.0378 9.61376 19.6294 8.99612 20.0887 8.59089C20.2265 8.46931 20.3888 8.35101 20.4997 8.27425Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9607 25.5956C25.9607 25.5956 24.0348 30.2575 18.7778 30.2575C18.4096 30.2575 18.1111 30.5247 18.1111 30.854C18.1111 31.1832 18.4096 31.4505 18.7778 31.4505C24.9363 31.4505 27.2103 26.0116 27.2103 26.0116C27.3385 25.703 27.1629 25.3593 26.8177 25.2446C26.4726 25.1298 26.0889 25.2871 25.9607 25.5956Z",
    fill: "#F69D25"
  })));
}

export default SvgDrop;